export default __webpack_public_path__ + "static/media/tiktok.762543db.svg";